import React from 'react'
import {withRouter, Link} from 'react-router-dom'
import {Pagination, PaginationItem, PaginationLink} from 'reactstrap'

let Paginator = ({ count, pageSize, currentPage, baseURL }) => {
    const previousPage = currentPage > 1 ? parseInt(currentPage) - 1 : 0
    const finalPage = Math.ceil(count / pageSize)
    const nextPage = currentPage < finalPage ? parseInt(currentPage) + 1 : 0
    let URLForPage = (page) => `${baseURL}${page}`
  
    const rangeSize = 5
    const rangePadding = Math.floor(rangeSize / 2)
  
    let startRange = currentPage - rangePadding
    if (startRange < 1) {
        startRange = 1
    }
    let endRange = startRange + rangeSize - 1
    if (endRange > finalPage) {
        endRange = finalPage
        startRange = Math.max(endRange - rangeSize + 1, 1)
    }
  
    let range = []
    for (let page = startRange; page <= endRange; page++) {
        range.push(page)
    }

    return <Pagination>
        <PaginationItem disabled={!previousPage}>
            <Link className="page-link" aria-label="Previous" to={URLForPage(previousPage)}>
                <span aria-hidden="true">&laquo;</span>
                <span className="sr-only">Previous</span>
            </Link>
        </PaginationItem>

        {range.map((page) =>
            <PaginationItem key={page} active={parseInt(page) === parseInt(currentPage)}>
                <Link className="page-link" to={URLForPage(page)}>
                    {page}
                </Link>
            </PaginationItem>
        )}

        {(finalPage === endRange ? null :
            <PaginationItem disabled>
                <PaginationLink href="javascript:void(0)">
                    &hellip;
                </PaginationLink>
            </PaginationItem>)}

        {(finalPage === endRange ? null :
            <PaginationItem>
                <Link className="page-link" to={URLForPage(finalPage)}>
                    {finalPage}
                </Link>
            </PaginationItem>)}

        <PaginationItem disabled={!nextPage}>
            <Link className="page-link" aria-label="Next" to={URLForPage(nextPage)}>
                <span aria-hidden="true">&raquo;</span>
                <span className="sr-only">Next</span>
            </Link>
        </PaginationItem>
    </Pagination>
}

export default withRouter(Paginator)


// WEBPACK FOOTER //
// ./src/components/ui/Paginator.js